<template>
  <div class="s-content">
    <div class="admin-page-title">
      <h1>Domains</h1>
    </div>
    <div class="panel panel-default dashboard-datatable__panel">
      <div class="panel-body dashboard-datatable__wrap">
        <div id="resources-table_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
          <div class="row">
            <div class="col-sm-12">
              <table ref="table" class="display table table-bordered table-hover table-responsive" cellspacing="0" width="100%">
                <thead>
                <tr>
                  <th class="align-center">Id</th>
                  <th class="align-center">Type</th>
                  <th class="align-center">Domain</th>
                  <th class="align-center">Name</th>
                  <th class="align-center">Username</th>
                  <th class="align-center">Agency</th>
                  <th class="align-center">Expire at</th>
                  <th class="align-center">Status</th>
                </tr>
                </thead>
                <tfoot>
                <tr>
                  <th class="align-center">Id</th>
                  <th class="align-center">Type</th>
                  <th class="align-center">Domain</th>
                  <th class="align-center">Name</th>
                  <th class="align-center">Username</th>
                  <th class="align-center">Agency</th>
                  <th class="align-center">Expiry At</th>
                  <th class="align-center">Status</th>
                </tr>
                </tfoot>
                <tbody>
                <tr v-for="domain in domains">
                  <td class="align-center">{{ domain.id }}</td>
                  <td class="align-center">{{ getType(domain) }}</td>
                  <td class="align-center">{{ domain.domain }}</td>
                  <td class="align-center">{{ getFullName(domain.user.illustrator) }}</td>
                  <td class="align-center">
                    <a class="btn btn-link" :href="routeLoginAsIllustrator.replace(':id', domain.user.id)">
                      {{ domain.user.name }}
                    </a>
                  </td>
                  <td class="align-center">
                    {{ getAgencyName(domain) }}
                  </td>
                  <td class="align-center">{{ getDate(domain.expire_at) }}</td>
                  <td class="align-center">
                    <div class="big-purple-button admin-button illustrator"
                         :class="getClassByLabel(domain.status)">
                      {{ showStatus(domain.status) }}
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from './../../../../mixins/helpers';

export default {
  mixins: [
    helpers
  ],

  props: {
    domains: {
      type: Array,
      required: true
    },

    routeLoginAsIllustrator: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      statuses: {
        inactive: 0,
        active: 1,
        not_completed: 2,
        expired: 3,
      },

      types: {
        namecheap: 'namecheap',
        gandi: 'gandi'
      }
    };
  },

  mounted() {
    $(this.$refs.table).DataTable({
      responsive: true
    });
  },

  methods: {
    getClassByLabel(status) {
      let className = '';

      switch(status) {
      case this.statuses.inactive:
        className = 'red-button';
        break;
      case this.statuses.expired:
        className = 'red-button';
        break;
      case this.statuses.active:
        className = 'green-button';
        break;
      case this.statuses.not_completed:
        className = 'warning-message';
        break;
      }

      return className;
    },

    showStatus(status) {
      let show = '';

      switch(status) {
      case this.statuses.inactive:
        show = 'Inactive';
        break;
      case this.statuses.active:
        show = 'Active';
        break;
      case this.statuses.not_completed:
        show = 'Not Completed';
        break;
      case this.statuses.expired:
        show = 'Expired';
        break;
      }

      return show;
    },

    getAgencyName(domain) {
      return domain.user.illustrator.agency ? domain.user.illustrator.agency.name : 'None';
    },

    getType(domain) {
      let type = '';

      switch(domain.type) {
      case this.types.namecheap:
        type = 'Namecheap';
        break;
      case this.types.gandi:
        type = 'Gandi';
        break;
      }

      return type;
    }
  }
};
</script>

<style>
  .dataTables_filter {
    float: right;
  }
</style>
